import { render, staticRenderFns } from "./UIModal.vue?vue&type=template&id=a810e86e&scoped=true"
import script from "./UIModal.vue?vue&type=script&lang=js"
export * from "./UIModal.vue?vue&type=script&lang=js"
import style0 from "./UIModal.vue?vue&type=style&index=0&id=a810e86e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a810e86e",
  null
  
)

export default component.exports